import deepmerge from 'deepmerge';
import Confirmation from './el/Confirmation/index.vue';
import ConflictModal from './el/Conflict/index.vue';
import ControlPanelLight from './index.vue';
import translations from './localization/dev';
import deprecatedTranslations from './localization/dev_deprecated';
import CreateLoginCardModal from './el/LoginCard/CreateLoginCardModal.vue';
import CreateMultipleUsersModal from './el/NewUser/CreateMultipleUsersModal.vue';
import CreateSingleUserModal from './el/NewUser/CreateSingleUserModal.vue';
import CreateUsersTable from './el/NewUser/CreateUsersTable.vue';
import EditGroup from './el/GroupSidePanel/EditGroup.vue';
import EditGroupModal from './el/GroupSidePanel/EditGroupModal.vue';
import EditUserInfo from './el/UserSidePanel/EditUser/EditUserInfo.vue';
import EditUserInfoModal from './el/UserSidePanel/EditUser/EditUserInfoModal.vue';
import Modal from './el/Modal.vue';
import SidePanelSection from './el/SidePanel/SidePanelSection.vue';
import SidePanelSectionItem from './el/SidePanel/SidePanelSectionItem.vue';
import useModal, { modals } from './composables/useModal';
import MemberChip from './el/GroupSidePanel/ManageMembers/MemberChip.vue';
import ManageContentSettingsModal from './el/UserSidePanel/ManageContentSettingsModal.vue';
import ManageUserContentSettingModal from './el/GroupSidePanel/ManageUserContentSettingModal.vue';
import { createErrorParser } from './error-utils';
import { memoizeFunction } from './composables/memoizeFunction';
import { useSidebarUser } from './composables/useSidebarUser';
import { useCurrentOrganization } from './composables/useCurrentOrganization';
import useToast from './composables/useToast';

import type { UserToCreate } from './el/NewUser/useCreateMultipleUsers';

const controlPanelLightDevTranslation = deepmerge(deprecatedTranslations, translations);

export {
  Confirmation,
  ConflictModal,
  ControlPanelLight,
  controlPanelLightDevTranslation,
  CreateLoginCardModal,
  CreateMultipleUsersModal,
  CreateSingleUserModal,
  CreateUsersTable,
  EditGroup,
  EditGroupModal,
  EditUserInfo,
  EditUserInfoModal,
  Modal,
  modals,
  SidePanelSection,
  SidePanelSectionItem,
  useModal,
  UserToCreate,
  MemberChip,
  createErrorParser,
  memoizeFunction,
  useSidebarUser,
  useCurrentOrganization,
  ManageContentSettingsModal,
  ManageUserContentSettingModal,
  useToast,
};
